
var GenesysChat = {
    constants: {
        chatBotDeploymentId: Shopify.country == "US" ? '2d781926-f5ea-40c0-a31a-1cbbab15cc65': '1ec8b27e-fea5-421e-acd4-9dca5b8b1a48',
        country: Shopify.country,
        languageCountry: Shopify.locale + "-" + Shopify.country,
        genesysApp: '.genesys-app',
        environment: 'prod-euw1',
        //genesysUrl: (countryCode == "US" || countryCode == "CA") ? "https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js" : "https://apps.mypurecloud.ie/genesys-bootstrap/genesys.min.js"
        genesysUrl: "https://apps.mypurecloud.ie/genesys-bootstrap/genesys.min.js"
    },

    init: function () {

        subscribe("change-country", () => {Genesys("command", "Messenger.clear")});

        (function (g, e, n, es, ys) {
            g['_genesysJs'] = e;
            g[e] =
                g[e] ||
                function () {
                    (g[e].q = g[e].q || []).push(arguments);
                };
            g[e].t = 1 * new Date();
            g[e].c = es;
            ys = document.createElement('script');
            ys.async = 1;
            ys.src = n;
            ys.charset = 'utf-8';
            document.head.appendChild(ys);
        })(window, 'Genesys', GenesysChat.constants.genesysUrl, {
            environment: GenesysChat.constants.environment,
            deploymentId: GenesysChat.constants.chatBotDeploymentId,
            debug: false
        });

        Genesys("command", "Database.set", {
            messaging: {
                customAttributes: {
                    "webmsg_brandcode": 'OP',
                    "webmsg_country": Shopify.country,
                    "webmsg_language": Shopify.locale + "-" + Shopify.country
                }
            }
        })

        let flag = true;
        const observer = new MutationObserver(() => {
            if(sessionStorage.getItem("showHelpChatbot") == null) {
                observer.disconnect();
                return;
            }
            if(flag) {
                flag = false;
                GenesysChat.buttonDisplaySettings();
            }
            if(GenesysChat.hideChat()) observer.disconnect();
        });
        observer.observe(document.body, {childList: true});

        this.bind();
    },

    bind: function () {
        // Contenenete logiche di binding, 
        // gestite tramite hook di Genesys per poter, ad esempio, 
        // tracciare gli analytics in caso di apertura o chiusura della chat

        Genesys('subscribe', 'Messenger.ready', function (o) {
            // if (sessionStorage.showHelpChatbot != null && $('#chatbot-element').length > 0) {
            //     $('#chatbot-element').show();
            // }
            // $('[aria-label="chat with us"]').css('pointer-events', 'unset');
            setTimeout(() => {
                if(sessionStorage.getItem("showHelpChatbot") != null) GenesysChat.hideChat();
                else document.querySelector(GenesysChat.constants.genesysApp).style.display = 'none';
            }, 1000);
        });

        Genesys('subscribe', 'MessagingService.messagesReceived', function (o) {
            if (o.data.messages[0].direction === 'Inbound') {//only messange send by user
                tealium_data2track.push({
                    'id': 'Click',
                    'data_element_id': 'X_X_ChatBot_Send',
                    'data_analytics_available_call': '1',
                });
            }
        });
        Genesys('subscribe', 'Conversations.opened', function (o) {


        });

        Genesys('subscribe', 'Conversations.closed', function (o) {
            GenesysChat.hideChat();

            tealium_data2track.push({
                'id': 'Click',
                'data_element_id': 'X_X_ChatBot_Close',
                'data_analytics_available_call': '1',
            });
        });

        // Custom button to open chat and close other modals
        document.querySelectorAll('.op-open-chat').forEach(elem => elem.addEventListener('click', (event) => {
            event.target.closest('dialog').click()
            if(event.target.closest('dialog')) {
                setTimeout(() => {
                GenesysChat.startChatbot();
                }, "500");
            }   
            
        }))

    },

    startChatbot: function (e) {
        // Avvio della chat Genesys
        Genesys("command", "Database.set", {
            messaging: {
                customAttributes: {
                    "webmsg_brandcode": 'OP',
                    "webmsg_country": Shopify.country,
                    "webmsg_language": Shopify.locale + "-" + Shopify.country
                }
            }
        });
        GenesysChat.showChat();
        Genesys("command", "Messenger.open", {},
            function (o) { }, // if resolved
            function (o) { // if the chat is opened but not dispyable 
                GenesysChat.showChat();
            }
        );

        sessionStorage.setItem("showHelpChatbot", "true");

        GenesysChat.buttonDisplaySettings();

        
    },

    buttonDisplaySettings: function () {
        let height = 0;
        document.querySelectorAll(".shopify-section-group-footer-group").forEach((node) => height += node.offsetHeight);
        document.addEventListener("scroll", () => {
            const scrollPosition = window.scrollY + window.innerHeight;
            const hidePosition = document.body.offsetHeight - height + window.innerHeight;
            if(scrollPosition > hidePosition) {
                GenesysChat.displayChatbotElement("none");
            } else {
                if(sessionStorage.getItem("showHelpChatbot") != null && document.getElementById('genesys-messenger').style.display == 'none'){
                    GenesysChat.displayChatbotElement("block");
                }
                    
            }
        })
    },

    openChat: function (e) {
        if (document.getElementById('genesys-mxg-container-frame').length > 0) {
            // Apertura della chat
            // if ($(".contact-us-form").length == 0) {
            //     sessionStorage.setItem('chatbotOpened', true); //save chat is opened no in contact us page
            // }
            tealium_data2track.push({
                'id': 'Click',
                'data_element_id': 'X_X_ChatBot_Open',
                'data_analytics_available_call': '1',
            });
            GenesysChat.startChatbot();
            GenesysChat.showChat();
            sessionStorage.setItem("showHelpChatbot", true);
        }
    },

    showChat: function (e) {
        // Visualizzazione della chat
        document.querySelector(GenesysChat.constants.genesysApp).style.display = 'block';
        this.displayChatbotElement("none");
        // $(GenesysChat.constants.genesysApp).show();
        //$('#chatbot-element').hide();
    },

    hideChat: function (e) {
        if(document.querySelector(GenesysChat.constants.genesysApp)) document.querySelector(GenesysChat.constants.genesysApp).style.display = 'none';
        // $(GenesysChat.constants.genesysApp).hide();
        if(sessionStorage.showHelpChatbot != null){
            this.displayChatbotElement("block");
        }
        
        // if (sessionStorage.showHelpChatbot != null && $('#chatbot-element').length > 0) {
        //     $('#chatbot-element').show();
        // }
        // sessionStorage.setItem("chatbotOpened", false);
    },

    displayChatbotElement(display) {
        const chatbot = document.querySelector("#chatbot-element");
        if(!chatbot) return;
        chatbot.style.display = display;
    }

    // onLoadHandler: function () {

    //     //calculate margin to hide entry point when touch the footer
    //     var margin;
    //     if (isOliver) {
    //         if ((window.mobilecheck() || window.tabletPortraitCheck())) {
    //             margin = ($('#chatbot-element').height() + parseFloat($('#chatbot-element').css('padding-top')) + parseFloat($('#chatbot-element').css('padding-bottom'))) * 4 + 'px';
    //         } else {
    //             margin = ($('#chatbot-element').height() + parseFloat($('#chatbot-element').css('padding-top')) + parseFloat($('#chatbot-element').css('padding-bottom'))) * 2 + 'px';
    //         }
    //     } else {
    //         margin = ($('#chatbot-element').height() + parseFloat($('#chatbot-element').css('padding-top')) + parseFloat($('#chatbot-element').css('padding-bottom'))) * 1.5 + 'px';
    //     }

    //     var options = {
    //         root: null,
    //         rootMargin: margin,
    //         threshold: 0.5
    //     }
    //     var observer = new IntersectionObserver(GenesysChat.onScrollHandler, options);

    //     var footerDesk = document.querySelector('.shopify-section-group-footer-group');
    //     observer.observe(footerDesk);
    // },
    // onScrollHandler: function (entries, observer) {
    //     entries.forEach(function (entry) {
    //         if (entry.isIntersecting) {
    //             $('#chatbot-element').hide();
    //         } else {
    //             if (sessionStorage.showHelpChatbot != null && $('#chatbot-element').length > 0 && $('#genesys-messenger').is(":hidden"))
    //                 $('#chatbot-element').show();
    //         }
    //     });
    // }
}

GenesysChat.init();

// document.addEventListener('DOMContentLoaded', function () {
//     GenesysChat.onLoadHandler();
// });

